"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState, type RefObject } from "react";
type Size = {
  width: number;
  height: number;
};

/** Tracks an element's size via ResizeObserver plus orientation/viewport listeners for iOS Safari. */
export function useContainerSize(ref) {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      width: 0,
      height: 0
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [size, setSize] = useState(t0);
  let t1;
  let t2;
  if ($[1] !== ref) {
    t1 = () => {
      const el = ref.current;
      if (!el) {
        return;
      }
      const sync = () => {
        const {
          width,
          height
        } = el.getBoundingClientRect();
        const next = {
          width: Math.max(0, Math.floor(width)),
          height: Math.max(0, Math.floor(height))
        };
        setSize(cur => cur.width === next.width && cur.height === next.height ? cur : next);
      };
      sync();
      const observer = new ResizeObserver(sync);
      observer.observe(el);
      window.addEventListener("orientationchange", sync);
      window.visualViewport?.addEventListener("resize", sync);
      return () => {
        observer.disconnect();
        window.removeEventListener("orientationchange", sync);
        window.visualViewport?.removeEventListener("resize", sync);
      };
    };
    t2 = [ref];
    $[1] = ref;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  return size;
}